export const parseNumberFromString = (
  otherwiseValue: number,
  stringNumber?: string,
) => {
  const pageFromLocation = Number(stringNumber);

  if (
    pageFromLocation === undefined ||
    Number.isNaN(pageFromLocation) ||
    pageFromLocation === null
  ) {
    return otherwiseValue;
  }

  return pageFromLocation;
};
